import "./QuotationDetailRouteInfo.scss";

import { IQuotation } from "pages/shipper/ShipmentQuotes/components/quotes/QuotesType";
import QuoteDetailRouteStopList from "./QuoteDetailRouteStopList";
import QuoteDetailRouteStops from "./QuoteDetailRouteStops";

type QuotationDetailRouteInfoProps = {
  currentQuotation: IQuotation;
};

function QuotationDetailRouteInfo(props: QuotationDetailRouteInfoProps) {
  const { currentQuotation } = props;

  if (!currentQuotation?.schedule?.quoted_pickup_date || !currentQuotation?.schedule?.quoted_time_delivery_date) {
    return null;
  }

  return (
    <div className="quotation-detail-route-info-container">
      <div className="quotation-detail-route-info">
        <div className="py-xl text-md font-semibold text-primary">Route</div>
        <QuoteDetailRouteStops currentQuotation={currentQuotation} />
      </div>
      <QuoteDetailRouteStopList currentQuotation={currentQuotation} />
    </div>
  );
}

export default QuotationDetailRouteInfo;
